import React from 'react';

const Footer = () => {
  return (
    <footer>
      &copy; {new Date().getFullYear()}, <a href="https://www.amandalutz.com">Amanda Lutz</a>. All rights reserved.
    </footer>
  );
};

export default Footer;
